class ErrorFilter {
    filters;
    constructor(filters) {
        this.filters = filters;
    }
    approve(error) {
        let message;
        let stack;
        let name;
        if (typeof error === 'string') {
            message = error;
        }
        else {
            message = error.message;
            stack = error.stack;
            name = error.name;
        }
        return !this.filters.some(filter => {
            return (message && filter.test(message)) || (stack && filter.test(stack)) || (name && filter.test(name));
        });
    }
}

export { ErrorFilter };
//# sourceMappingURL=ErrorFilter.mjs.map
